import { CircularProgress } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Summary {
  activeUsers: number
  numCodesSubmitted: number
  submissions: number
}

interface FormatValueProps {
  loading: boolean
  value: number
  label: string
}

async function fetchSummaries() {
  const { data } = await api.get('/api/v1/account/reports/summary')
  return data
}

const FormatValue = ({ loading, value, label }: FormatValueProps) => {
  return (
    <css.MetaDetail>
      <css.MetaDetailLabel>{label}</css.MetaDetailLabel>
      <css.MetaDetailValue>
        {loading ? <CircularProgress size={16} /> : Intl.NumberFormat().format(value)}
      </css.MetaDetailValue>
    </css.MetaDetail>
  )
}

export const Reports = () => {
  const { data: summary, isInitialLoading: isLoading } = useQuery<Summary>({
    queryKey: ['reportStats'],
    queryFn: () => fetchSummaries(),
    refetchOnWindowFocus: false,
  })

  const { activeUsers, numCodesSubmitted, submissions } = summary || {
    activeUsers: 0,
    numCodesSubmitted: 0,
    submissions: 0,
  }

  return (
    <css.Header>
      <css.TitleWrapper>
        <css.Title>{t`Welcome`}</css.Title>
      </css.TitleWrapper>
      <css.Meta>
        <FormatValue loading={isLoading} label={t`Users`} value={activeUsers} />
        <FormatValue loading={isLoading} label={t`Rows`} value={numCodesSubmitted} />
        <FormatValue loading={isLoading} label={t`Submissions`} value={submissions} />
      </css.Meta>
    </css.Header>
  )
}
